<template>
	<div class="wrap">
		<template v-if="menu">
			<div class="menu">
				<admin-navigation />
			</div>
		</template>
		<div class="contents">
			<router-view />
		</div>
	</div>
</template>

<script setup>
import AdminNavigation from "./AdminNavigation";
import {ref} from "vue"

const menu = ref(true);

const menuHandler = (show) => {
  menu.value = show;
};
</script>

<style scoped>
.wrap {
	min-width: 1024px;
}
</style>